module.exports = __webpack_public_path__ + "media/images/icons/bi-emoji-smile-f58c868b947854038049098265f98825.png";